// // src/pages/LeavePolicy.tsx
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import {
//     Container, Row, Col, Card, CardBody, CardHeader, Button, Badge,
//     Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label,
//     Input, Alert, Spinner, Table,
// } from 'reactstrap';
// import {
//     Plus, Edit, Trash2, RefreshCw, Eye, CheckCircle, XCircle,
//     PlusCircle, MinusCircle, UserPlus,
// } from 'react-feather';
// import BreadCrumb from '../../Components/Common/BreadCrumb';
// import TableContainer from '../../Components/Common/TableContainer';
// import { format } from 'date-fns';
// import { toast } from 'react-toastify';
// import { apiClient } from '../../helpers/api_helper';

// // ---------- Types ----------
// interface LeaveType {
//     id: number;
//     name: string;
//     short_name?: string;
//     color_hex?: string;
//     carry_forward: boolean;
//     is_active: boolean;
// }

// interface PolicyItem {
//     id?: number;
//     leave_type_id: number;
//     count: number;
//     is_paid: boolean;
//     period: number;
//     max_carry_forward?: number | null;
//     leaveType?: LeaveType;
// }

// interface LeavePolicy {
//     id: number;
//     name: string;
//     description?: string;
//     is_active: boolean;
//     created_at: string;
//     updated_at: string;
//     items: PolicyItem[];
// }

// interface EmployeeOption {
//     id: number;
//     name: string;
// }

// const PERIOD_OPTIONS = [
//     { value: 1, label: 'Yearly' },
//     { value: 2, label: 'Half-Yearly' },
//     { value: 3, label: 'Quarterly' },
// ];

// const emptyItem = (): PolicyItem => ({
//     leave_type_id: 0,
//     count: 0,
//     is_paid: true,
//     period: 1,
//     max_carry_forward: null,
// });

// const LeavePolicy: React.FC = () => {
//     // ---------- State ----------
//     const [policies, setPolicies] = useState<LeavePolicy[]>([]);
//     const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
//     const [employees, setEmployees] = useState<EmployeeOption[]>([]);

//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');

//     // Create/Edit modal
//     const [modal, setModal] = useState(false);
//     const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
//     const [selectedPolicy, setSelectedPolicy] = useState<LeavePolicy | null>(null);
//     const [formData, setFormData] = useState({
//         name: '',
//         description: '',
//         is_active: true,
//     });
//     const [items, setItems] = useState<PolicyItem[]>([emptyItem()]);
//     const [submitting, setSubmitting] = useState(false);
//     const [formError, setFormError] = useState('');

//     // Delete modal
//     const [deleteModal, setDeleteModal] = useState(false);
//     const [deleting, setDeleting] = useState(false);
//     const [policyToDelete, setPolicyToDelete] = useState<LeavePolicy | null>(null);

//     // View modal
//     const [viewModal, setViewModal] = useState(false);
//     const [viewingPolicy, setViewingPolicy] = useState<LeavePolicy | null>(null);

//     // Assign modal
//     const [assignModal, setAssignModal] = useState(false);
//     const [assigning, setAssigning] = useState(false);
//     const [assignData, setAssignData] = useState<{
//         policy: LeavePolicy | null;
//         employee_id: number | '';
//     }>({ policy: null, employee_id: '' });
//     const [assignError, setAssignError] = useState('');

//     // ---------- Fetchers ----------
//     const fetchPolicies = useCallback(async () => {
//         try {
//             const res = (await apiClient.get('/leave-policies')) as LeavePolicy[];
//             console.log("policy",res)
//             setPolicies(res || []);
//         } catch (err: any) {
//             setError(err.message || 'Failed to load policies');
//             toast.error('Failed to load leave policies');
//         }
//     }, []);

//     const fetchLeaveTypes = useCallback(async () => {
//         try {
//             const res = (await apiClient.get('/leave-types')) as LeaveType[];
//             setLeaveTypes(res || []);
//         } catch (err: any) {
//             toast.error('Failed to load leave types');
//         }
//     }, []);

//     const fetchEmployees = useCallback(async () => {
//         try {
//             const res:any = (await apiClient.get('/employees/all')) as EmployeeOption[];
//             console.log('employee',res)
//             setEmployees(res.data || []);
//         } catch (err: any) {
//             // Non-fatal — assign modal just won't have options
//             console.error('Failed to load employees', err);
//         }
//     }, []);

//     const fetchAll = useCallback(async () => {
//         setLoading(true);
//         setError('');
//         try {
//             await Promise.all([fetchPolicies(), fetchLeaveTypes(), fetchEmployees()]);
//         } finally {
//             setLoading(false);
//         }
//     }, [fetchPolicies, fetchLeaveTypes, fetchEmployees]);

//     useEffect(() => {
//         fetchAll();
//     }, [fetchAll]);

//     // ---------- Helpers ----------
//     const periodLabel = (p: number) =>
//         PERIOD_OPTIONS.find(o => o.value === p)?.label || '—';

//     const getStatusBadge = (active: boolean) =>
//         active ? (
//             <Badge color="success">
//                 <CheckCircle size={12} className="me-1" /> Active
//             </Badge>
//         ) : (
//             <Badge color="warning">
//                 <XCircle size={12} className="me-1" /> Inactive
//             </Badge>
//         );

//     const getPaidBadge = (paid: boolean) =>
//         paid ? <Badge color="primary">Paid</Badge> : <Badge color="secondary">Unpaid</Badge>;

//     const formatDate = (d: string) => {
//         try {
//             return format(new Date(d), 'dd MMM yyyy HH:mm');
//         } catch {
//             return '—';
//         }
//     };

//     // ---------- Create / Edit ----------
//     const openAddModal = () => {
//         setModalMode('add');
//         setSelectedPolicy(null);
//         setFormData({ name: '', description: '', is_active: true });
//         setItems([emptyItem()]);
//         setFormError('');
//         setModal(true);
//     };

//     const openEditModal = (policy: LeavePolicy) => {
//         setModalMode('edit');
//         setSelectedPolicy(policy);
//         setFormData({
//             name: policy.name,
//             description: policy.description || '',
//             is_active: policy.is_active,
//         });
//         setItems(
//             policy.items.length
//                 ? policy.items.map(i => ({
//                     leave_type_id: i.leave_type_id,
//                     count: Number(i.count),
//                     is_paid: i.is_paid,
//                     period: i.period,
//                     max_carry_forward:
//                         i.max_carry_forward != null ? Number(i.max_carry_forward) : null,
//                 }))
//                 : [emptyItem()]
//         );
//         setFormError('');
//         setModal(true);
//     };

//     const closeModal = () => {
//         setModal(false);
//         setSelectedPolicy(null);
//         setFormError('');
//     };

//     const updateItem = (index: number, patch: Partial<PolicyItem>) => {
//         setItems(prev =>
//             prev.map((it, i) => (i === index ? { ...it, ...patch } : it))
//         );
//     };

//     const addItemRow = () => setItems(prev => [...prev, emptyItem()]);

//     const removeItemRow = (index: number) =>
//         setItems(prev => prev.filter((_, i) => i !== index));

//     const validateForm = (): string | null => {
//         if (!formData.name.trim()) return 'Policy name is required';
//         if (!items.length) return 'Add at least one leave item';

//         const seen = new Set<number>();
//         for (let i = 0; i < items.length; i++) {
//             const it = items[i];
//             if (!it.leave_type_id) return `Row ${i + 1}: select a leave type`;
//             if (seen.has(it.leave_type_id))
//                 return `Row ${i + 1}: duplicate leave type`;
//             seen.add(it.leave_type_id);
//             if (it.count < 0) return `Row ${i + 1}: count must be ≥ 0`;
//             if (![1, 2, 3].includes(it.period))
//                 return `Row ${i + 1}: invalid period`;
//         }
//         return null;
//     };

//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();
//         const v = validateForm();
//         if (v) {
//             setFormError(v);
//             return;
//         }

//         setSubmitting(true);
//         setFormError('');

//         const payload = {
//             name: formData.name.trim(),
//             description: formData.description.trim() || undefined,
//             is_active: formData.is_active,
//             items: items.map(it => ({
//                 leave_type_id: Number(it.leave_type_id),
//                 count: Number(it.count),
//                 is_paid: it.is_paid,
//                 period: Number(it.period),
//                 max_carry_forward:
//                     it.max_carry_forward != null && it.max_carry_forward !== ('' as any)
//                         ? Number(it.max_carry_forward)
//                         : null,
//             })),
//         };

//         try {
//             if (modalMode === 'add') {
//                 await apiClient.post('/leave-policies', payload);
//                 toast.success('Policy created');
//             } else {
//                 await apiClient.put(`/leave-policies/${selectedPolicy?.id}`, payload);
//                 toast.success('Policy updated');
//             }
//             closeModal();
//             await fetchPolicies();
//         } catch (err: any) {
//             setFormError(err.message || 'Failed to save policy');
//             toast.error('Failed to save policy');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     // ---------- Delete ----------
//     const openDeleteModal = (policy: LeavePolicy) => {
//         setPolicyToDelete(policy);
//         setDeleteModal(true);
//     };

//     const confirmDelete = async () => {
//         if (!policyToDelete) return;
//         setDeleting(true);
//         try {
//             await apiClient.delete(`/leave-policies/${policyToDelete.id}`);
//             toast.success('Policy deactivated');
//             setDeleteModal(false);
//             await fetchPolicies();
//         } catch (err: any) {
//             toast.error(err.message || 'Failed to delete policy');
//         } finally {
//             setDeleting(false);
//             setPolicyToDelete(null);
//         }
//     };

//     // ---------- View ----------
//     const openViewModal = (policy: LeavePolicy) => {
//         setViewingPolicy(policy);
//         setViewModal(true);
//     };

//     // ---------- Assign ----------
//     const openAssignModal = (policy: LeavePolicy) => {
//         setAssignData({ policy, employee_id: '' });
//         setAssignError('');
//         setAssignModal(true);
//     };

//     const closeAssignModal = () => {
//         setAssignModal(false);
//         setAssignData({ policy: null, employee_id: '' });
//         setAssignError('');
//     };

//     const handleAssign = async () => {
//         if (!assignData.policy || !assignData.employee_id) {
//             setAssignError('Select an employee');
//             return;
//         }
//         setAssigning(true);
//         setAssignError('');
//         try {
//             await apiClient.post('/leave-policies/assign', {
//                 employee_id: Number(assignData.employee_id),
//                 policy_id: assignData.policy.id,
//             });
//             toast.success('Policy assigned');
//             closeAssignModal();
//         } catch (err: any) {
//             setAssignError(err.message || 'Failed to assign');
//             toast.error('Failed to assign policy');
//         } finally {
//             setAssigning(false);
//         }
//     };

//     // ---------- Table Columns ----------
//     const columns = useMemo(
//         () => [
//             {
//                 header: 'SI.No',
//                 accessorKey: 'id',
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: (c: any) => <strong>{c.row.index + 1}</strong>,
//             },
//             {
//                 header: 'Name',
//                 accessorKey: 'name',
//                 cell: (c: any) => <span className="fw-semibold">{c.getValue()}</span>,
//             },
//             {
//                 header: 'Leave Types',
//                 accessorKey: 'items',
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: (c: any) => {
//                     const its: PolicyItem[] = c.getValue() || [];
//                     return <Badge color="info">{its.length}</Badge>;
//                 },
//             },
//             {
//                 header: 'Status',
//                 accessorKey: 'is_active',
//                 cell: (c: any) => getStatusBadge(c.getValue()),
//             },
//             {
//                 header: 'Created',
//                 accessorKey: 'created_at',
//                 cell: (c: any) => formatDate(c.getValue()),
//             },
//             {
//                 header: 'Actions',
//                 accessorKey: 'actions',
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: (c: any) => {
//                     const policy: LeavePolicy = c.row.original;
//                     return (
//                         <div className="d-flex gap-1">
//                             <Button color="info" size="sm" title="View" onClick={() => openViewModal(policy)}>
//                                 <Eye size={14} />
//                             </Button>
//                             <Button color="primary" size="sm" title="Edit" onClick={() => openEditModal(policy)}>
//                                 <Edit size={14} />
//                             </Button>
//                             <Button color="success" size="sm" title="Assign" onClick={() => openAssignModal(policy)}>
//                                 <UserPlus size={14} />
//                             </Button>
//                             <Button color="danger" size="sm" title="Delete" onClick={() => openDeleteModal(policy)}>
//                                 <Trash2 size={14} />
//                             </Button>
//                         </div>
//                     );
//                 },
//             },
//         ],
//         []
//     );

//     // ---------- Render ----------
//     return (
//         <div className="page-content">
//             <Container fluid>
//                 <BreadCrumb title="Leave Policies" pageTitle="Leave Policies" />

//                 <Row>
//                     <Col lg={12}>
//                         <Card>
//                             <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
//                                 <h5 className="card-title mb-0">Leave Policies</h5>
//                                 <div className="d-flex gap-2">
//                                     <Button
//                                         color="secondary"
//                                         size="sm"
//                                         onClick={fetchAll}
//                                         disabled={loading}
//                                     >
//                                         <RefreshCw size={14} className="me-1" /> Refresh
//                                     </Button>
//                                     <Button color="primary" size="sm" onClick={openAddModal}>
//                                         <Plus size={14} className="me-1" /> Add Policy
//                                     </Button>
//                                 </div>
//                             </CardHeader>

//                             <CardBody>
//                                 {error && (
//                                     <Alert color="danger" className="mb-3">
//                                         {error}
//                                     </Alert>
//                                 )}

//                                 {loading ? (
//                                     <div className="text-center py-5">
//                                         <Spinner color="primary" className="me-2" />
//                                         <span>Loading policies...</span>
//                                     </div>
//                                 ) : policies.length === 0 ? (
//                                     <div className="text-center py-5">
//                                         <i className="ri-file-list-3-line display-4 text-muted" />
//                                         <h5 className="mt-3">No policies yet</h5>
//                                         <p className="text-muted">
//                                             Click "Add Policy" to create your first leave policy.
//                                         </p>
//                                     </div>
//                                 ) : (
//                                     <TableContainer
//                                         columns={columns}
//                                         data={policies}
//                                         customPageSize={10}
//                                         tableClass="table-striped"
//                                         theadClass="table-light"
//                                     />
//                                 )}
//                             </CardBody>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>

//             {/* ---------- Create/Edit Modal ---------- */}
//             <Modal isOpen={modal} toggle={closeModal} size="xl">
//                 <ModalHeader toggle={closeModal}>
//                     {modalMode === 'add' ? 'Add Leave Policy' : 'Edit Leave Policy'}
//                 </ModalHeader>
//                 <ModalBody>
//                     {formError && <Alert color="danger">{formError}</Alert>}

//                     <Form onSubmit={handleSubmit}>
//                         <Row className="g-3 mb-3">
//                             <Col md={6}>
//                                 <FormGroup>
//                                     <Label>Policy Name *</Label>
//                                     <Input
//                                         bsSize="sm"
//                                         value={formData.name}
//                                         onChange={e =>
//                                             setFormData(p => ({ ...p, name: e.target.value }))
//                                         }
//                                         placeholder="e.g. Standard 2025"
//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={4}>
//                                 <FormGroup>
//                                     <Label>Description</Label>
//                                     <Input
//                                         bsSize="sm"
//                                         value={formData.description}
//                                         onChange={e =>
//                                             setFormData(p => ({ ...p, description: e.target.value }))
//                                         }
//                                         placeholder="Optional"
//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={2} className="d-flex align-items-end">
//                                 <FormGroup check className="mb-2">
//                                     <Label check>
//                                         <Input
//                                             type="checkbox"
//                                             checked={formData.is_active}
//                                             onChange={e =>
//                                                 setFormData(p => ({ ...p, is_active: e.target.checked }))
//                                             }
//                                         />
//                                         <span className="ms-2">Active</span>
//                                     </Label>
//                                 </FormGroup>
//                             </Col>
//                         </Row>

//                         <div className="d-flex justify-content-between align-items-center mb-2">
//                             <h6 className="mb-0">Leave Items</h6>
//                             <Button color="outline-primary" size="sm" onClick={addItemRow} type="button">
//                                 <PlusCircle size={14} className="me-1" /> Add Row
//                             </Button>
//                         </div>

//                         <div className="table-responsive">
//                             <Table bordered size="sm" className="align-middle mb-0">
//                                 <thead className="table-light">
//                                     <tr>
//                                         <th style={{ minWidth: 200 }}>Leave Type</th>
//                                         <th style={{ width: 100 }}>Count</th>
//                                         <th style={{ width: 100 }}>Paid</th>
//                                         <th style={{ width: 140 }}>Period</th>
//                                         <th style={{ width: 140 }}>Max Carry Fwd</th>
//                                         <th style={{ width: 50 }}></th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {items.map((it, idx) => (
//                                         <tr key={idx}>
//                                             <td>
//                                                 <Input
//                                                     type="select"
//                                                     bsSize="sm"
//                                                     value={it.leave_type_id || ''}
//                                                     onChange={e =>
//                                                         updateItem(idx, {
//                                                             leave_type_id: Number(e.target.value),
//                                                         })
//                                                     }
//                                                 >
//                                                     <option value="">-- Select --</option>
//                                                     {leaveTypes.map(lt => (
//                                                         <option key={lt.id} value={lt.id}>
//                                                             {lt.name}
//                                                         </option>
//                                                     ))}
//                                                 </Input>
//                                             </td>
//                                             <td>
//                                                 <Input
//                                                     type="number"
//                                                     bsSize="sm"
//                                                     step="0.5"
//                                                     min="0"
//                                                     value={it.count}
//                                                     onChange={e =>
//                                                         updateItem(idx, { count: Number(e.target.value) })
//                                                     }
//                                                 />
//                                             </td>
//                                             <td>
//                                                 <FormGroup check className="mb-0">
//                                                     <Input
//                                                         type="checkbox"
//                                                         checked={it.is_paid}
//                                                         onChange={e =>
//                                                             updateItem(idx, { is_paid: e.target.checked })
//                                                         }
//                                                     />
//                                                 </FormGroup>
//                                             </td>
//                                             <td>
//                                                 <Input
//                                                     type="select"
//                                                     bsSize="sm"
//                                                     value={it.period}
//                                                     onChange={e =>
//                                                         updateItem(idx, { period: Number(e.target.value) })
//                                                     }
//                                                 >
//                                                     {PERIOD_OPTIONS.map(o => (
//                                                         <option key={o.value} value={o.value}>
//                                                             {o.label}
//                                                         </option>
//                                                     ))}
//                                                 </Input>
//                                             </td>
//                                             <td>
//                                                 <Input
//                                                     type="number"
//                                                     bsSize="sm"
//                                                     step="0.5"
//                                                     min="0"
//                                                     placeholder="Full"
//                                                     disabled={it.period === 1}
//                                                     value={
//                                                         it.max_carry_forward != null
//                                                             ? it.max_carry_forward
//                                                             : ''
//                                                     }
//                                                     onChange={e =>
//                                                         updateItem(idx, {
//                                                             max_carry_forward:
//                                                                 e.target.value === ''
//                                                                     ? null
//                                                                     : Number(e.target.value),
//                                                         })
//                                                     }
//                                                 />
//                                             </td>
//                                             <td className="text-center">
//                                                 {items.length > 1 && (
//                                                     <Button
//                                                         color="link"
//                                                         className="text-danger p-0"
//                                                         onClick={() => removeItemRow(idx)}
//                                                         type="button"
//                                                     >
//                                                         <MinusCircle size={16} />
//                                                     </Button>
//                                                 )}
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>

//                         {items.some(i => i.period === 1) && (
//                             <small className="text-muted d-block mt-2">
//                                 Yearly items do not carry forward (max carry fwd disabled).
//                             </small>
//                         )}
//                     </Form>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="light" onClick={closeModal} disabled={submitting}>
//                         Cancel
//                     </Button>
//                     <Button color="primary" onClick={handleSubmit} disabled={submitting}>
//                         {submitting ? (
//                             <>
//                                 <Spinner size="sm" className="me-2" /> Saving...
//                             </>
//                         ) : modalMode === 'add' ? (
//                             'Create'
//                         ) : (
//                             'Update'
//                         )}
//                     </Button>
//                 </ModalFooter>
//             </Modal>

//             {/* ---------- Delete Modal ---------- */}
//             <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
//                 <ModalHeader toggle={() => setDeleteModal(false)}>Confirm Delete</ModalHeader>
//                 <ModalBody>
//                     <p>
//                         Deactivate policy <strong>"{policyToDelete?.name}"</strong>?
//                     </p>
//                     <Alert color="warning" className="mb-0">
//                         Assigned employees keep history. You can re-activate later.
//                     </Alert>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="light" onClick={() => setDeleteModal(false)} disabled={deleting}>
//                         Cancel
//                     </Button>
//                     <Button color="danger" onClick={confirmDelete} disabled={deleting}>
//                         {deleting ? (
//                             <>
//                                 <Spinner size="sm" className="me-2" /> Deleting...
//                             </>
//                         ) : (
//                             'Delete'
//                         )}
//                     </Button>
//                 </ModalFooter>
//             </Modal>

//             {/* ---------- View Modal ---------- */}
//             <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg">
//                 <ModalHeader toggle={() => setViewModal(false)}>Policy Details</ModalHeader>
//                 <ModalBody>
//                     {viewingPolicy && (
//                         <>
//                             <Row className="mb-3">
//                                 <Col md={4}><strong>Name:</strong></Col>
//                                 <Col md={8}>{viewingPolicy.name}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}><strong>Description:</strong></Col>
//                                 <Col md={8}>{viewingPolicy.description || '—'}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}><strong>Status:</strong></Col>
//                                 <Col md={8}>{getStatusBadge(viewingPolicy.is_active)}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}><strong>Created:</strong></Col>
//                                 <Col md={8}>{formatDate(viewingPolicy.created_at)}</Col>
//                             </Row>

//                             <h6 className="mt-3">Leave Items</h6>
//                             <div className="table-responsive">
//                                 <Table bordered size="sm" className="mb-0">
//                                     <thead className="table-light">
//                                         <tr>
//                                             <th>Leave Type</th>
//                                             <th>Count</th>
//                                             <th>Paid</th>
//                                             <th>Period</th>
//                                             <th>Max Carry Fwd</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {viewingPolicy.items.map((it, i) => (
//                                             <tr key={i}>
//                                                 <td>{it.leaveType?.name || `#${it.leave_type_id}`}</td>
//                                                 <td>{Number(it.count)}</td>
//                                                 <td>{getPaidBadge(it.is_paid)}</td>
//                                                 <td>{periodLabel(it.period)}</td>
//                                                 <td>
//                                                     {it.period === 1
//                                                         ? '—'
//                                                         : it.max_carry_forward != null
//                                                         ? Number(it.max_carry_forward)
//                                                         : 'Full'}
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </Table>
//                             </div>
//                         </>
//                     )}
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="secondary" onClick={() => setViewModal(false)}>
//                         Close
//                     </Button>
//                     {viewingPolicy && (
//                         <Button
//                             color="primary"
//                             onClick={() => {
//                                 setViewModal(false);
//                                 openEditModal(viewingPolicy);
//                             }}
//                         >
//                             <Edit size={14} className="me-1" /> Edit
//                         </Button>
//                     )}
//                 </ModalFooter>
//             </Modal>

//             {/* ---------- Assign Modal ---------- */}
//             <Modal isOpen={assignModal} toggle={closeAssignModal}>
//                 <ModalHeader toggle={closeAssignModal}>Assign Policy</ModalHeader>
//                 <ModalBody>
//                     {assignError && <Alert color="danger">{assignError}</Alert>}
//                     <p>
//                         Assign <strong>{assignData.policy?.name}</strong> to an employee.
//                         Any existing active policy will be deactivated.
//                     </p>
//                     <FormGroup>
//                         <Label>Employee *</Label>
//                         <Input
//                             type="select"
//                             bsSize="sm"
//                             value={assignData.employee_id}
//                             onChange={e =>
//                                 setAssignData(p => ({
//                                     ...p,
//                                     employee_id: e.target.value ? Number(e.target.value) : '',
//                                 }))
//                             }
//                         >
//                             <option value="">-- Select Employee --</option>
//                             {employees.map(emp => (
//                                 <option key={emp.id} value={emp.id}>
//                                     {emp.name}
//                                 </option>
//                             ))}
//                         </Input>
//                     </FormGroup>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="light" onClick={closeAssignModal} disabled={assigning}>
//                         Cancel
//                     </Button>
//                     <Button color="success" onClick={handleAssign} disabled={assigning}>
//                         {assigning ? (
//                             <>
//                                 <Spinner size="sm" className="me-2" /> Assigning...
//                             </>
//                         ) : (
//                             'Assign'
//                         )}
//                     </Button>
//                 </ModalFooter>
//             </Modal>
//         </div>
//     );
// };

// export default LeavePolicy;

// src/pages/LeavePolicy.tsx
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
    Container, Row, Col, Card, CardBody, CardHeader, Button, Badge,
    Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label,
    Input, Alert, Spinner, Table,
} from 'reactstrap';
import {
    Plus, Edit, Trash2, RefreshCw, Eye, CheckCircle, XCircle,
    PlusCircle, MinusCircle, UserPlus,
} from 'react-feather';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import TableContainer from '../../Components/Common/TableContainer';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { apiClient } from '../../helpers/api_helper';

// ---------- Types ----------
interface LeaveType {
    id: number;
    name: string;
    short_name?: string;
    color_hex?: string;
    carry_forward: boolean;
    is_active: boolean;
}

// Form-level item: count / max_carry_forward are STRINGS for clean UX
interface PolicyItemForm {
    leave_type_id: number;
    count: string;
    is_paid: boolean;
    period: number;
    max_carry_forward: string;
}

// Server-shape item (used when receiving from API)
interface PolicyItem {
    id?: number;
    leave_type_id: number;
    count: number | string;
    is_paid: boolean;
    period: number;
    max_carry_forward?: number | string | null;
    leaveType?: LeaveType;
}

interface LeavePolicy {
    id: number;
    name: string;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    items: PolicyItem[];
}

interface EmployeeOption {
    id: number;
    name: string;
}

const PERIOD_OPTIONS = [
    { value: 1, label: 'Yearly' },
    { value: 2, label: 'Half-Yearly' },
    { value: 3, label: 'Quarterly' },
];

const emptyItem = (): PolicyItemForm => ({
    leave_type_id: 0,
    count: '',
    is_paid: true,
    period: 1,
    max_carry_forward: '',
});

const LeavePolicy: React.FC = () => {
    // ---------- State ----------
    const [policies, setPolicies] = useState<LeavePolicy[]>([]);
    const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
    const [employees, setEmployees] = useState<EmployeeOption[]>([]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Create/Edit modal
    const [modal, setModal] = useState(false);
    const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
    const [selectedPolicy, setSelectedPolicy] = useState<LeavePolicy | null>(null);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        is_active: true,
    });
    const [items, setItems] = useState<PolicyItemForm[]>([emptyItem()]);
    const [submitting, setSubmitting] = useState(false);
    const [formError, setFormError] = useState('');

    // Delete modal
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [policyToDelete, setPolicyToDelete] = useState<LeavePolicy | null>(null);

    // View modal
    const [viewModal, setViewModal] = useState(false);
    const [viewingPolicy, setViewingPolicy] = useState<LeavePolicy | null>(null);

    // Assign modal
    const [assignModal, setAssignModal] = useState(false);
    const [assigning, setAssigning] = useState(false);
    const [assignData, setAssignData] = useState<{
        policy: LeavePolicy | null;
        employee_id: number | '';
    }>({ policy: null, employee_id: '' });
    const [assignError, setAssignError] = useState('');

    // ---------- Fetchers ----------
    const fetchPolicies = useCallback(async () => {
        try {
            const res = (await apiClient.get('/leave-policies')) as LeavePolicy[];
            setPolicies(res || []);
        } catch (err: any) {
            setError(err.message || 'Failed to load policies');
            toast.error('Failed to load leave policies');
        }
    }, []);

    const fetchLeaveTypes = useCallback(async () => {
        try {
            const res = (await apiClient.get('/leave-types')) as LeaveType[];
            setLeaveTypes(res || []);
        } catch (err: any) {
            toast.error('Failed to load leave types');
        }
    }, []);

    const fetchEmployees = useCallback(async () => {
        try {
            const res: any = await apiClient.get('/employees/all');
            setEmployees(res.data || []);
        } catch (err: any) {
            console.error('Failed to load employees', err);
        }
    }, []);

    const fetchAll = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            await Promise.all([fetchPolicies(), fetchLeaveTypes(), fetchEmployees()]);
        } finally {
            setLoading(false);
        }
    }, [fetchPolicies, fetchLeaveTypes, fetchEmployees]);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    // ---------- Helpers ----------
    const periodLabel = (p: number) =>
        PERIOD_OPTIONS.find(o => o.value === p)?.label || '—';

    const getStatusBadge = (active: boolean) =>
        active ? (
            <Badge color="success">
                <CheckCircle size={12} className="me-1" /> Active
            </Badge>
        ) : (
            <Badge color="warning">
                <XCircle size={12} className="me-1" /> Inactive
            </Badge>
        );

    const getPaidBadge = (paid: boolean) =>
        paid ? <Badge color="primary">Paid</Badge> : <Badge color="secondary">Unpaid</Badge>;

    const formatDate = (d: string) => {
        try {
            return format(new Date(d), 'dd MMM yyyy HH:mm');
        } catch {
            return '—';
        }
    };

    // ---------- Create / Edit ----------
    const openAddModal = () => {
        setModalMode('add');
        setSelectedPolicy(null);
        setFormData({ name: '', description: '', is_active: true });
        setItems([emptyItem()]);
        setFormError('');
        setModal(true);
    };

    const openEditModal = (policy: LeavePolicy) => {
        setModalMode('edit');
        setSelectedPolicy(policy);
        setFormData({
            name: policy.name,
            description: policy.description || '',
            is_active: policy.is_active,
        });
        setItems(
            policy.items.length
                ? policy.items.map(i => ({
                    leave_type_id: i.leave_type_id,
                    count: i.count != null ? String(i.count) : '',
                    is_paid: i.is_paid,
                    period: i.period,
                    max_carry_forward:
                        i.max_carry_forward != null ? String(i.max_carry_forward) : '',
                }))
                : [emptyItem()]
        );
        setFormError('');
        setModal(true);
    };

    const closeModal = () => {
        setModal(false);
        setSelectedPolicy(null);
        setFormError('');
    };

    const updateItem = (index: number, patch: Partial<PolicyItemForm>) => {
        setItems(prev =>
            prev.map((it, i) => (i === index ? { ...it, ...patch } : it))
        );
    };

    const addItemRow = () => setItems(prev => [...prev, emptyItem()]);

    const removeItemRow = (index: number) =>
        setItems(prev => prev.filter((_, i) => i !== index));

    // Filter leave types per row: hide ones already selected in OTHER rows
    const getAvailableLeaveTypesForRow = (rowIndex: number): LeaveType[] => {
        const usedElsewhere = new Set(
            items
                .filter((_, i) => i !== rowIndex)
                .map(it => it.leave_type_id)
                .filter(id => id > 0)
        );
        return leaveTypes.filter(lt => !usedElsewhere.has(lt.id));
    };

    const validateForm = (): string | null => {
        if (!formData.name.trim()) return 'Policy name is required';
        if (!items.length) return 'Add at least one leave item';

        const seen = new Set<number>();
        for (let i = 0; i < items.length; i++) {
            const it = items[i];
            if (!it.leave_type_id) return `Row ${i + 1}: select a leave type`;
            if (seen.has(it.leave_type_id))
                return `Row ${i + 1}: duplicate leave type`;
            seen.add(it.leave_type_id);

            if (it.count === '' || isNaN(Number(it.count)))
                return `Row ${i + 1}: enter a valid count`;
            if (Number(it.count) < 0) return `Row ${i + 1}: count must be ≥ 0`;

            if (![1, 2, 3].includes(it.period))
                return `Row ${i + 1}: invalid period`;

            if (it.max_carry_forward !== '' && isNaN(Number(it.max_carry_forward)))
                return `Row ${i + 1}: max carry forward must be a number`;
        }
        return null;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const v = validateForm();
        if (v) {
            setFormError(v);
            return;
        }

        setSubmitting(true);
        setFormError('');

        const payload = {
            name: formData.name.trim(),
            description: formData.description.trim() || undefined,
            is_active: formData.is_active,
            items: items.map(it => ({
                leave_type_id: Number(it.leave_type_id),
                count: Number(it.count),
                is_paid: it.is_paid,
                period: Number(it.period),
                max_carry_forward:
                    it.max_carry_forward === '' ? null : Number(it.max_carry_forward),
            })),
        };

        try {
            if (modalMode === 'add') {
                await apiClient.post('/leave-policies', payload);
                toast.success('Policy created');
            } else {
                await apiClient.put(`/leave-policies/${selectedPolicy?.id}`, payload);
                toast.success('Policy updated');
            }
            closeModal();
            await fetchPolicies();
        } catch (err: any) {
            setFormError(err.message || 'Failed to save policy');
            toast.error('Failed to save policy');
        } finally {
            setSubmitting(false);
        }
    };

    // ---------- Delete ----------
    const openDeleteModal = (policy: LeavePolicy) => {
        setPolicyToDelete(policy);
        setDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (!policyToDelete) return;
        setDeleting(true);
        try {
            await apiClient.delete(`/leave-policies/${policyToDelete.id}`);
            toast.success('Policy deactivated');
            setDeleteModal(false);
            await fetchPolicies();
        } catch (err: any) {
            toast.error(err.message || 'Failed to delete policy');
        } finally {
            setDeleting(false);
            setPolicyToDelete(null);
        }
    };

    // ---------- View ----------
    const openViewModal = (policy: LeavePolicy) => {
        setViewingPolicy(policy);
        setViewModal(true);
    };

    // ---------- Assign ----------
    const openAssignModal = (policy: LeavePolicy) => {
        setAssignData({ policy, employee_id: '' });
        setAssignError('');
        setAssignModal(true);
    };

    const closeAssignModal = () => {
        setAssignModal(false);
        setAssignData({ policy: null, employee_id: '' });
        setAssignError('');
    };

    const handleAssign = async () => {
        if (!assignData.policy || !assignData.employee_id) {
            setAssignError('Select an employee');
            return;
        }
        setAssigning(true);
        setAssignError('');
        try {
            await apiClient.post('/leave-policies/assign', {
                employee_id: Number(assignData.employee_id),
                policy_id: assignData.policy.id,
            });
            toast.success('Policy assigned');
            closeAssignModal();
        } catch (err: any) {
            setAssignError(err.message || 'Failed to assign');
            toast.error('Failed to assign policy');
        } finally {
            setAssigning(false);
        }
    };

    // ---------- Table Columns ----------
    const columns = useMemo(
        () => [
            {
                header: 'SI.No',
                accessorKey: 'id',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (c: any) => <strong>{c.row.index + 1}</strong>,
            },
            {
                header: 'Name',
                accessorKey: 'name',
                cell: (c: any) => <span className="fw-semibold">{c.getValue()}</span>,
            },
            {
                header: 'Leave Types',
                accessorKey: 'items',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (c: any) => {
                    const its: PolicyItem[] = c.getValue() || [];
                    return <Badge color="info">{its.length}</Badge>;
                },
            },
            {
                header: 'Status',
                accessorKey: 'is_active',
                cell: (c: any) => getStatusBadge(c.getValue()),
            },
            {
                header: 'Created',
                accessorKey: 'created_at',
                cell: (c: any) => formatDate(c.getValue()),
            },
            {
                header: 'Actions',
                accessorKey: 'actions',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (c: any) => {
                    const policy: LeavePolicy = c.row.original;
                    return (
                        <div className="d-flex gap-1">
                            <Button color="info" size="sm" title="View" onClick={() => openViewModal(policy)}>
                                <Eye size={14} />
                            </Button>
                            <Button color="primary" size="sm" title="Edit" onClick={() => openEditModal(policy)}>
                                <Edit size={14} />
                            </Button>
                            <Button color="success" size="sm" title="Assign" onClick={() => openAssignModal(policy)}>
                                <UserPlus size={14} />
                            </Button>
                            <Button color="danger" size="sm" title="Delete" onClick={() => openDeleteModal(policy)}>
                                <Trash2 size={14} />
                            </Button>
                        </div>
                    );
                },
            },
        ],
        []
    );

    // ---------- Render ----------
    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Leave Policies" pageTitle="Leave Policies" />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <h5 className="card-title mb-0">Leave Policies</h5>
                                <div className="d-flex gap-2">
                                    <Button
                                        color="secondary"
                                        size="sm"
                                        onClick={fetchAll}
                                        disabled={loading}
                                    >
                                        <RefreshCw size={14} className="me-1" /> Refresh
                                    </Button>
                                    <Button color="primary" size="sm" onClick={openAddModal}>
                                        <Plus size={14} className="me-1" /> Add Policy
                                    </Button>
                                </div>
                            </CardHeader>

                            <CardBody>
                                {error && (
                                    <Alert color="danger" className="mb-3">
                                        {error}
                                    </Alert>
                                )}

                                {loading ? (
                                    <div className="text-center py-5">
                                        <Spinner color="primary" className="me-2" />
                                        <span>Loading policies...</span>
                                    </div>
                                ) : policies.length === 0 ? (
                                    <div className="text-center py-5">
                                        <i className="ri-file-list-3-line display-4 text-muted" />
                                        <h5 className="mt-3">No policies yet</h5>
                                        <p className="text-muted">
                                            Click "Add Policy" to create your first leave policy.
                                        </p>
                                    </div>
                                ) : (
                                    <TableContainer
                                        columns={columns}
                                        data={policies}
                                        customPageSize={10}
                                        tableClass="table-striped"
                                        theadClass="table-light"
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* ---------- Create/Edit Modal ---------- */}
            <Modal isOpen={modal} toggle={closeModal} size="xl">
                <ModalHeader toggle={closeModal}>
                    {modalMode === 'add' ? 'Add Leave Policy' : 'Edit Leave Policy'}
                </ModalHeader>
                <ModalBody>
                    {formError && <Alert color="danger">{formError}</Alert>}

                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3 mb-3">
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Policy Name *</Label>
                                    <Input
                                        bsSize="sm"
                                        value={formData.name}
                                        onChange={e =>
                                            setFormData(p => ({ ...p, name: e.target.value }))
                                        }
                                        placeholder="e.g. Standard 2025"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Description</Label>
                                    <Input
                                        bsSize="sm"
                                        value={formData.description}
                                        onChange={e =>
                                            setFormData(p => ({ ...p, description: e.target.value }))
                                        }
                                        placeholder="Optional"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2} className="d-flex align-items-end">
                                <FormGroup check className="mb-2">
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            checked={formData.is_active}
                                            onChange={e =>
                                                setFormData(p => ({ ...p, is_active: e.target.checked }))
                                            }
                                        />
                                        <span className="ms-2">Active</span>
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0">Leave Items</h6>
                            <Button color="outline-primary" size="sm" onClick={addItemRow} type="button">
                                <PlusCircle size={14} className="me-1" /> Add Row
                            </Button>
                        </div>

                        <div className="table-responsive">
                            <Table bordered size="sm" className="align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ minWidth: 200 }}>Leave Type</th>
                                        <th style={{ width: 100 }}>Count</th>
                                        <th style={{ width: 100 }}>Paid</th>
                                        <th style={{ width: 140 }}>Period</th>
                                        <th style={{ width: 140 }}>Max Carry Fwd</th>
                                        <th style={{ width: 50 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((it, idx) => {
                                        const available = getAvailableLeaveTypesForRow(idx);
                                        // Ensure the currently selected one is present
                                        const current = leaveTypes.find(
                                            lt => lt.id === it.leave_type_id
                                        );
                                        const options =
                                            current && !available.some(a => a.id === current.id)
                                                ? [current, ...available]
                                                : available;

                                        return (
                                            <tr key={idx}>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        bsSize="sm"
                                                        value={it.leave_type_id || ''}
                                                        onChange={e =>
                                                            updateItem(idx, {
                                                                leave_type_id: Number(e.target.value),
                                                            })
                                                        }
                                                    >
                                                        <option value="">-- Select --</option>
                                                        {options.map(lt => (
                                                            <option key={lt.id} value={lt.id}>
                                                                {lt.name}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </td>
                                                <td>
                                                    <Input
                                                        type="number"
                                                        bsSize="sm"
                                                        step="0.5"
                                                        min="0"
                                                        placeholder="e.g. 12"
                                                        value={it.count}
                                                        onChange={e =>
                                                            updateItem(idx, {
                                                                count: e.target.value,
                                                            })
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <FormGroup check className="mb-0">
                                                        <Input
                                                            type="checkbox"
                                                            checked={it.is_paid}
                                                            onChange={e =>
                                                                updateItem(idx, { is_paid: e.target.checked })
                                                            }
                                                        />
                                                    </FormGroup>
                                                </td>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        bsSize="sm"
                                                        value={it.period}
                                                        onChange={e =>
                                                            updateItem(idx, {
                                                                period: Number(e.target.value),
                                                            })
                                                        }
                                                    >
                                                        {PERIOD_OPTIONS.map(o => (
                                                            <option key={o.value} value={o.value}>
                                                                {o.label}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </td>
                                                <td>
                                                    <Input
                                                        type="number"
                                                        bsSize="sm"
                                                        step="0.5"
                                                        min="0"
                                                        placeholder="Full"
                                                        disabled={it.period === 1}
                                                        value={it.max_carry_forward}
                                                        onChange={e =>
                                                            updateItem(idx, {
                                                                max_carry_forward: e.target.value,
                                                            })
                                                        }
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    {items.length > 1 && (
                                                        <Button
                                                            color="link"
                                                            className="text-danger p-0"
                                                            onClick={() => removeItemRow(idx)}
                                                            type="button"
                                                        >
                                                            <MinusCircle size={16} />
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>

                        {items.some(i => i.period === 1) && (
                            <small className="text-muted d-block mt-2">
                                Yearly items do not carry forward (max carry fwd disabled).
                            </small>
                        )}
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={closeModal} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={handleSubmit} disabled={submitting}>
                        {submitting ? (
                            <>
                                <Spinner size="sm" className="me-2" /> Saving...
                            </>
                        ) : modalMode === 'add' ? (
                            'Create'
                        ) : (
                            'Update'
                        )}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* ---------- Delete Modal ---------- */}
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
                <ModalHeader toggle={() => setDeleteModal(false)}>Confirm Delete</ModalHeader>
                <ModalBody>
                    <p>
                        Deactivate policy <strong>"{policyToDelete?.name}"</strong>?
                    </p>
                    <Alert color="warning" className="mb-0">
                        Assigned employees keep history. You can re-activate later.
                    </Alert>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={() => setDeleteModal(false)} disabled={deleting}>
                        Cancel
                    </Button>
                    <Button color="danger" onClick={confirmDelete} disabled={deleting}>
                        {deleting ? (
                            <>
                                <Spinner size="sm" className="me-2" /> Deleting...
                            </>
                        ) : (
                            'Delete'
                        )}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* ---------- View Modal ---------- */}
            <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg">
                <ModalHeader toggle={() => setViewModal(false)}>Policy Details</ModalHeader>
                <ModalBody>
                    {viewingPolicy && (
                        <>
                            <Row className="mb-3">
                                <Col md={4}><strong>Name:</strong></Col>
                                <Col md={8}>{viewingPolicy.name}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}><strong>Description:</strong></Col>
                                <Col md={8}>{viewingPolicy.description || '—'}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}><strong>Status:</strong></Col>
                                <Col md={8}>{getStatusBadge(viewingPolicy.is_active)}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}><strong>Created:</strong></Col>
                                <Col md={8}>{formatDate(viewingPolicy.created_at)}</Col>
                            </Row>

                            <h6 className="mt-3">Leave Items</h6>
                            <div className="table-responsive">
                                <Table bordered size="sm" className="mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Leave Type</th>
                                            <th>Count</th>
                                            <th>Paid</th>
                                            <th>Period</th>
                                            <th>Max Carry Fwd</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {viewingPolicy.items.map((it, i) => (
                                            <tr key={i}>
                                                <td>{it.leaveType?.name || `#${it.leave_type_id}`}</td>
                                                <td>{Number(it.count)}</td>
                                                <td>{getPaidBadge(it.is_paid)}</td>
                                                <td>{periodLabel(it.period)}</td>
                                                <td>
                                                    {it.period === 1
                                                        ? '—'
                                                        : it.max_carry_forward != null &&
                                                          it.max_carry_forward !== ''
                                                        ? Number(it.max_carry_forward)
                                                        : 'Full'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setViewModal(false)}>
                        Close
                    </Button>
                    {viewingPolicy && (
                        <Button
                            color="primary"
                            onClick={() => {
                                setViewModal(false);
                                openEditModal(viewingPolicy);
                            }}
                        >
                            <Edit size={14} className="me-1" /> Edit
                        </Button>
                    )}
                </ModalFooter>
            </Modal>

            {/* ---------- Assign Modal ---------- */}
            <Modal isOpen={assignModal} toggle={closeAssignModal}>
                <ModalHeader toggle={closeAssignModal}>Assign Policy</ModalHeader>
                <ModalBody>
                    {assignError && <Alert color="danger">{assignError}</Alert>}
                    <p>
                        Assign <strong>{assignData.policy?.name}</strong> to an employee.
                        Any existing active policy will be deactivated.
                    </p>
                    <FormGroup>
                        <Label>Employee *</Label>
                        <Input
                            type="select"
                            bsSize="sm"
                            value={assignData.employee_id}
                            onChange={e =>
                                setAssignData(p => ({
                                    ...p,
                                    employee_id: e.target.value ? Number(e.target.value) : '',
                                }))
                            }
                        >
                            <option value="">-- Select Employee --</option>
                            {employees.map(emp => (
                                <option key={emp.id} value={emp.id}>
                                    {emp.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={closeAssignModal} disabled={assigning}>
                        Cancel
                    </Button>
                    <Button color="success" onClick={handleAssign} disabled={assigning}>
                        {assigning ? (
                            <>
                                <Spinner size="sm" className="me-2" /> Assigning...
                            </>
                        ) : (
                            'Assign'
                        )}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default LeavePolicy;